// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


/* IM USING THIS ONE  */

.App {
  /* text-align: center; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: black;
  justify-content: center;
  align-items: center;
}

.phone-containerr {
  max-width: 430px; /* Set width for iPhone 14 Pro Max */
  width: 100%;
  height: 100vh; /* Set height for iPhone 14 Pro Max */
  background-color: black;
  border-radius: 40px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  position: fixed;
}

.screen {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  /* padding-bottom: 5px; */
  box-sizing: border-box;
}



.icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.icon {
  width: 70px;
  height: 70px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  background-color: rgba(255, 255, 255, 0.1);
}

.dock {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  background: #282c34;
  bottom: 20px;
  width: 90%;
  border-radius: 40px;
}

.app-icondock {
  margin: 10px;
  /* width: 50px;
  height: 50px; */
  /* border-radius: 10px; */
  text-align: center;
  background-color: #282c34;
  color: white;
}

.app-icondock img {
  width: 100%;
  height: 100%;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,uGAAuG;EACvG,mCAAmC;EACnC,kCAAkC;AACpC;;;AAGA,uBAAuB;;AAEvB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,oCAAoC;EACtD,WAAW;EACX,aAAa,EAAE,qCAAqC;EACpD,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ;iBACe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n\n/* IM USING THIS ONE  */\n\n.App {\n  /* text-align: center; */\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n  background-color: black;\n  justify-content: center;\n  align-items: center;\n}\n\n.phone-containerr {\n  max-width: 430px; /* Set width for iPhone 14 Pro Max */\n  width: 100%;\n  height: 100vh; /* Set height for iPhone 14 Pro Max */\n  background-color: black;\n  border-radius: 40px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n  position: fixed;\n}\n\n.screen {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  /* padding-bottom: 5px; */\n  box-sizing: border-box;\n}\n\n\n\n.icons {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.icon {\n  width: 70px;\n  height: 70px;\n  margin: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 15px;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.dock {\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n  background: #282c34;\n  bottom: 20px;\n  width: 90%;\n  border-radius: 40px;\n}\n\n.app-icondock {\n  margin: 10px;\n  /* width: 50px;\n  height: 50px; */\n  /* border-radius: 10px; */\n  text-align: center;\n  background-color: #282c34;\n  color: white;\n}\n\n.app-icondock img {\n  width: 100%;\n  height: 100%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
